import { render, staticRenderFns } from "./VxCellTooltip.vue?vue&type=template&id=362f01b4&scoped=true&"
import script from "./VxCellTooltip.vue?vue&type=script&lang=js&"
export * from "./VxCellTooltip.vue?vue&type=script&lang=js&"
import style0 from "./VxCellTooltip.vue?vue&type=style&index=0&id=362f01b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362f01b4",
  null
  
)

export default component.exports